import { Platform } from 'react-native';

const TOKEN_KEY = 'clubhouse.token';
let memoryToken: string | undefined;

export function getStoredToken() {
  if (Platform.OS === 'web' && typeof localStorage !== 'undefined') {
    return localStorage.getItem(TOKEN_KEY) ?? undefined;
  }
  return memoryToken;
}

export function setStoredToken(token?: string) {
  memoryToken = token;
  if (Platform.OS === 'web' && typeof localStorage !== 'undefined') {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  }
}
